import React from "react";
import { Table } from "antd";
import { adnPageSize } from "../GeneralConfigurations";
import { useTranslation } from "react-i18next";
import "./AdnTable.css";

const AdnTable = ({
  columns,
  data,
  handleChange,
  currentPage,
  pageSize = adnPageSize,
  totalRecords,
  handleChangePage,
  expandable,
  rowExpandable,
  onExpand,
  showPagination = true,
  getRowClassName,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <>
      {totalRecords != null ? (
        <p className="table-results">
          {totalRecords} {t("table.resultsFound")}
        </p>
      ) : null}
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        onChange={handleChange}
        expandable={{
          expandedRowRender: expandable,
          onExpand: onExpand,
          rowExpandable: rowExpandable,
        }}
        scroll={{ x: 1000 }}
        rowClassName={getRowClassName}
        pagination={
          showPagination === true
            ? {
                position: ["bottomCenter"],
                current: currentPage,
                pageSize: pageSize,
                total: totalRecords,
                onChange: handleChangePage,
                pageSizeOptions: [],
              }
            : false
        }
        style={{ paddingTop: "1rem" }}
        {...props}
      />
    </>
  );
};

export default AdnTable;
